import { parseAsBoolean, parseAsString, useQueryStates } from 'nuqs'

export function useFilterApplications() {
  return useQueryStates({
    freeSearch: parseAsString,
    tag: parseAsString,
    requiresApiUser: parseAsBoolean,
    requiresEntityAccount: parseAsBoolean,
    isActive: parseAsBoolean.withDefault(false),
  })
}
